export default () => ({
  backdrop: {
    zIndex: 1000,
    color: '#FFFFFF',
  },
});
